<template>
    <div class="row">
        <div class="col-12">
            <a href="/dashboard" @click.prevent="$router.back()" class="small">&lt;&nbsp;{{$ml.get('Back')}}</a>
        </div>
        <div class="col-12">
            <div class="row p-2">
                <div class="col-12">
                    <h4 class="text-uppercase text-center pb-3">{{$ml.get('Select_Plan_To_Upgrade')}}</h4>
                </div>
                <div class="col-6" v-for="plan in availablePlans" @click="selectPlan(plan)">
                    <Plan class="qf-cursor-pointer" :plan="plan">
                        <div class="d-flex">
                            <div class="col text-left h4 pb-0">
                                {{$ml.get('TOTAL')}}:
                            </div>
                            <div class="col text-right h4 pb-0">
                                {{plan.yearly_price}}
                            </div>
                        </div>
                    </Plan>
                </div>
            </div>
        </div>
        <div class="col-12 pt-5" v-if="selectedPlan.plan_name.length">
            <div class="row p-2">
                <div class="col-12">
                    <h5>{{$ml.get('Selected_Plan')}}: <strong>{{selectedPlan.plan_name}}</strong></h5>
                </div>
                <div class="col-12">
                    <form @submit.prevent="submitPayment">
                        <div class="row justify-content-center align-items-center">
                            <div class="col-12 mt-5">
                                <h4 class="text-uppercase pb-3 text-center">{{$ml.get('payment_options')}}</h4>
                            </div>
                            <div class="col-7">
                                <PaymentOptions @updatePaymentData="updatePaymentData" />
                                <div class="row justify-content-center align-items-center pt-4">
                                    <div class="col-7 text-center">
                                        <font-awesome-icon icon="spinner" size="2x" class="fa-spin" v-if="loading"/>
                                        <button type="submit" class="btn btn-lg btn-warning form-control text-uppercase"
                                                :disabled="!selectedPlan.plan_name"
                                                v-else>
                                            {{$ml.get('upgrade')}}
                                        </button>
                                    </div>
                                </div>
                                <div class="row justify-content-center align-items-center"
                                     v-if="errorMessages.generalError.length">
                                    <div class="col-5 form-group">
                                        <small class="form-text text-danger">
                                            {{$ml.get('general_error_msg')}}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PaymentOptions from "../../common/PaymentOptions";
    export default {
        name: 'UpgradePlan',
        components: {PaymentOptions},
        data() {
            return {
                availablePlans: [],
                currentPlan: {},
                selectedPlan: {
                    id: '',
                    plan_name: ''
                },
                loggedUser: {
                    card_holder: ''
                },
                errorMessages: {
                    generalError: ''
                },
                loading: false
            }
        },
        mounted() {
            this.$store.dispatch('availablePlans').then(response => {
                this.availablePlans = response.available_plans;
                this.currentPlan = response.current_plan;
            });

            this.loggedUser.card_holder = `${this.$store.state.loggedUser.first_name} ${this.$store.state.loggedUser.last_name}`;
        },
        methods: {
            selectPlan(plan) {
                this.selectedPlan = plan;
            },
            updatePaymentData(paymentData) {
                debugger;
            },
            submitPayment() {
                if (!this.loading) {
                    this.errorMessages = {
                        card_holder: '',
                        generalError: ''
                    };

                    this.$validator.validateAll().then((result) => {

                        // TODO: finish the validation when payment system is integrated
                        // and link and send payment information to the backend

                        this.loading = true;
                        this.$store.dispatch('upgrade', this.selectedPlan.id).then(response => {
                            this.loading = false;
                            this.$store.commit('setLoggedUser', response);
                            this.$router.push({name: 'EditLoggedUser'});
                        }).catch(error => {
                            if (error.status === 400) {
                                error.data.forEach(obj => {
                                    this.errorMessages[obj.property_path] = obj.message;
                                });
                            } else {
                                this.errorMessages.generalError = 'error';
                            }
                            this.loading = false;
                        });
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>

